import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './router'
import { setupCalendar, Calendar, DatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import { initMsal } from '@/auth/authPopup'
import { registerSignInCallback } from '@/shared/susiHelper'
import { handleRedirect } from '@/auth/authRedirect'

const pinia = createPinia()
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routes
})
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(setupCalendar, {})

app.component('VCalendar', Calendar)
app.component('VDatePicker', DatePicker)

// Initialize MSAL after Pinia is installed (the auth modules resolve Pinia
// stores), register the sign-in event handler, then process any pending B2C
// redirect before mounting. This is the single, ordered auth bootstrap that
// replaces the old module-eval initialization (events-app#913). Wrapped in an
// async function rather than top-level await so the entry module stays
// synchronous and the mount is guaranteed to run after init resolves.
async function bootstrap() {
    try {
        await initMsal()
        registerSignInCallback()
        await handleRedirect()
    } catch (error) {
        // An auth-init failure (e.g. createPublicClientApplication or the redirect
        // handler rejecting) must not block the whole SPA from rendering. Log it
        // and mount anyway — auth-dependent UI degrades but the app still loads,
        // matching the old behavior where mount ran unconditionally (events-app#913).
        console.error('Auth initialization failed; mounting without it:', error)
    } finally {
        app.mount('#app')
    }
}

bootstrap()
